import { Component, input, computed } from '@angular/core';
import { BaseViewComponent, BadgeKind, BadgeColor } from '@sb/library/base';

@Component({
    selector: 'lib-badge',
    templateUrl: './badge.component.html',
    styleUrl: './badge.component.scss'
})
export class BadgeComponent extends BaseViewComponent {
    readonly kind = input<BadgeKind>(BadgeKind.Count);
    readonly color = input<BadgeColor>(BadgeColor.Attention);
    readonly text = input<number | string>();
    
    readonly displayText = computed(() => {
        const value = this.text();
        if (typeof value === 'number' && value > 99) {
            return '99+';
        }
        return String(value ?? '');
    });
}
